var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 14C4.5 14.83 5.17 15.5 6 15.5C6.83 15.5 7.5 14.83 7.5 14C7.5 13.17 6.83 12.5 6 12.5C5.17 12.5 4.5 13.17 4.5 14ZM4.5 8C4.5 8.83 5.17 9.5 6 9.5C6.83 9.5 7.5 8.83 7.5 8C7.5 7.17 6.83 6.5 6 6.5C5.17 6.5 4.5 7.17 4.5 8ZM4.5 20C4.5 20.8233 5.17669 21.5 6 21.5C6.82331 21.5 7.5 20.8233 7.5 20C7.5 19.1767 6.83459 18.5 6 18.5C5.16541 18.5 4.5 19.1767 4.5 20ZM25 20C25 19.4477 24.5523 19 24 19H10C9.44772 19 9 19.4477 9 20C9 20.5523 9.44772 21 10 21H24C24.5523 21 25 20.5523 25 20ZM25 14C25 13.4477 24.5523 13 24 13H10C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15H24C24.5523 15 25 14.5523 25 14ZM10 9H24C24.5523 9 25 8.55228 25 8C25 7.44772 24.5523 7 24 7H10C9.44772 7 9 7.44772 9 8C9 8.55228 9.44772 9 10 9Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListOutline);
export default __webpack_public_path__ + "static/media/list_outline.6aff22f4591c2fa45bdee05aa9337a17.svg";
export { ForwardRef as ReactComponent };